// User lookup service (SMB-3541 — Manual Booking).
//
// Ops cannot type a customer's userId directly, so Manual Booking resolves it
// from the customer's email:
//   POST /app/v1/users/email   body: { email }
//
// Sent the SAME way as every other admin call (dropnet/deal-code, flight
// management, etc.): through apiClient, which encrypts the request body and
// attaches the standard auth headers (x-access-token + x-api-key) on ENDPOINT,
// then decrypts the response. Callers read the { statusCode, message, data }
// envelope directly.
import { apiPost } from "./apiClient";

/**
 * Resolve a customer by email.
 * @param {string} email
 * @returns {Promise<object>} { statusCode, message, data: { id, name, email, ... } }
 */
export const getUserByEmail = (email, opts = {}) =>
  apiPost("/app/v1/users/email", { email }, opts);

// Pull the userId out of the response (data.id per the users/email contract),
// tolerant of a few nesting/naming variants.
export const extractUserId = (res) => {
  const d = res?.data?.data ?? res?.data ?? res ?? {};
  return d.id || d.userId || d.userID || null;
};

// Best-effort display name, if present.
export const extractUserName = (res) => {
  const d = res?.data?.data ?? res?.data ?? res ?? {};
  const name = d.name || [d.firstName, d.lastName].filter(Boolean).join(" ").trim();
  return name || null;
};

export default { getUserByEmail, extractUserId, extractUserName };
